import React from 'react';
import AITryOn from './AITryOn';
import './VirtualTryOnSection.scss';

const VirtualTryOnSection = () => {
  return (
    <section className='virtual-tryon-section'>
      <div className='virtual-tryon-section__container'>
        {/* Interactive Demo - Full AITryOn Component */}
        <AITryOn />

        {/* Decorative Elements */}
        <div className='virtual-tryon-section__decoration' aria-hidden='true' />
      </div>
    </section>
  );
};
export default VirtualTryOnSection;
